import React, { useContext } from "react";
import { ProcessContext } from "../../../../../../../contexts/ProcessContext";
import { fakeFormsAddParticipantToLoan } from "../../../../../../../utils/fakeFormsData";
import { useStepHandler } from "../../../../../../../utils/hooks/useStepHandler";
import {
  ONBOARDING_PARTICIPANT_ROLES,
  STEP_GROUP_IDS,
} from "../../../../../../shared/config";
import {
  LOAN_SUMMARY_AND_ADJUST_STEP_NAMES,
  PHONE_NUMBER_PREFIX,
} from "../../../config";
import { ParticipantContactData } from "./components/ParticipantContactData";
import { ParticipantPersonalData } from "./components/ParticipantPersonalData";
import { v4 as uuidv4 } from "uuid";
import { Box } from "@material-ui/core";
import BackButton from "../../../../../../shared/components/BackButton";
import { useState } from "react";
import { useActionCallback } from "../../../../../../../utils/hooks/useActionCallback";
import { FLOW_MESSAGES } from "../../../../../../shared/components/flowMessages/components";
BackButton;
export const AddParticipantToLoan = ({ setModuleStepGroup }) => {
  const {
    state: { loan },
    dispatch,
  } = useContext(ProcessContext);

  const FORM_NAMES = {
    PARTICIPANT_PERSONAL_DATA: "PARTICIPANT_PERSONAL_DATA",
    PARTICIPANT_CONTACT_DATA: "PARTICIPANT_CONTACT_DATA",
  };

  const [selectedRole, setSelectedRole] = useState(undefined);

  const onSubmitModule = (values) => {
    patchBorrowerOnboardingDetailsByRole(values);
  };

  const patchBorrowerOnboardingDetailsByRole = (values) => {
    const body = {
      op: "processPatchSetBorrowerOnboardingDetailsByRole",
      id: loan.id,
      role: values.participantRole,
      borrower_onboarding_details_type: ONBOARDING_PARTICIPANT_ROLES.BORROWER,
      borrower_onboarding_details_id: uuidv4(),
      invitation_email: values.participantEmail,
      invitation_first_name: values.participantFirstName,
      invitation_last_name: values.participantLastName,
      invitation_phone_number: `${PHONE_NUMBER_PREFIX}${values.participantPhoneNumber}`,
      invitation_relation: values.participantRelation,
      invitation_document_number: values.participantDocumentNumber,
    };
    dispatch({
      type: "PROCESS_PATCH_SET_BORROWER_ONBOARDING_DETAILS_BY_ROLE",
      payload: body,
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: true },
    });
  };

  useActionCallback(
    "PROCESS_PATCH_SET_BORROWER_ONBOARDING_DETAILS_BY_ROLE_FULFILLED",
    () => {
      dispatch({
        type: "REQUEST_GET_LOAN",
        payload: loan.id,
      });
    }
  );

  useActionCallback(
    "PROCESS_PATCH_SET_BORROWER_ONBOARDING_DETAILS_BY_ROLE_REJECTED",
    () => {
      dispatch({
        type: "SET_FLOW_LOADING",
        payload: { show: false },
      });
    }
  );

  useActionCallback("REQUEST_GET_LOAN_FULFILLED", () => {
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.CO_BORROWER_ADDED.id, fadeIn: true },
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
    setTimeout(() => {
      setModuleStepGroup(LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.SUMMARY_AND_ADJUST);
    }, 300);
  });

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsAddParticipantToLoan
  );

  const { manageGroup, submitStep, onBack, backButtonVisible, getStepData } =
    currentModuleStepHandler;

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: FORM_NAMES.PARTICIPANT_PERSONAL_DATA,
      show: () => true,
    },
    {
      id: FORM_NAMES.PARTICIPANT_CONTACT_DATA,
      show: () => true,
    },
  ];

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.AddParticipantToLoan;
  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    STEP_GROUP_STEPS_ARRAY
  );

  const addParticipantBackButtonBehavior = () => {
    if (stepGroupStepToShow === FORM_NAMES.PARTICIPANT_PERSONAL_DATA) {
      return setModuleStepGroup(
        LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.SUMMARY_AND_ADJUST
      );
    } else {
      return onBack();
    }
  };

  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton
          onBack={addParticipantBackButtonBehavior}
          show={
            stepGroupStepToShow === FORM_NAMES.PARTICIPANT_PERSONAL_DATA ||
            backButtonVisible
          }
        />
      </Box>
      {stepGroupStepToShow === FORM_NAMES.PARTICIPANT_PERSONAL_DATA && (
        <ParticipantPersonalData
          loan={loan}
          onSubmitForm={submitStep}
          data={getStepData()}
          setSelectedRole={setSelectedRole}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.PARTICIPANT_CONTACT_DATA && (
        <ParticipantContactData
          onSubmitForm={submitStep}
          data={getStepData()}
          selectedRole={selectedRole}
        />
      )}
    </>
  );
};
